import React from "react";
import { IAlertProps } from "components/Alert/Alert.interface";
import {
  AlertCloseButton,
  AlertContainer,
  AlertContent,
  AlertIcon,
} from "components/Alert/Alert.styled";
import { Paragraph, Title } from "components/Text";

const Alert = (props: IAlertProps) => {
  return (
    <>
      {props.show && (
        <AlertContainer
          className={`alert alert-${props.type} alert-dismissible fade show`}
          role="alert"
        >
          {props.icon && (
            <AlertIcon className="col-2">
              <i className={`cl ${props.icon}`}></i>
            </AlertIcon>
          )}
          <AlertContent
            className={`alert-content ${props.icon ? "col-8" : "col-10"}`}
          >
            <Title>{props.title}</Title>
            <Paragraph>{props.message}</Paragraph>
          </AlertContent>
          <AlertIcon className={`${props.icon && "col-2"}`}>
            <AlertCloseButton
              className={`close-button alert-${props.type}`}
              type="button"
              data-dismiss="alert"
              aria-label="Close"
              onClick={props.onClose}
            >
              <span aria-hidden="true">&times;</span>
            </AlertCloseButton>
          </AlertIcon>
        </AlertContainer>
      )}
    </>
  );
};

export default Alert;
